import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      // Force l'activation immédiate d'un nouveau SW dès qu'il est installé,
      // au lieu d'attendre la fermeture de tous les onglets.
      const promoteWaiting = () => {
        if (reg.waiting) { try { reg.waiting.postMessage({ type: "skip-waiting" }); } catch {} }
      };
      if (reg.waiting) promoteWaiting();
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) promoteWaiting();
        });
      });
    }).catch(() => {});
    // Recharge la page quand un nouveau SW a pris le contrôle (via message ou controllerchange),
    // pour que les livreurs chargent toujours le bon bundle après un déploiement.
    let reloaded = false;
    const doReload = () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    };
    navigator.serviceWorker.addEventListener("controllerchange", doReload);
    navigator.serviceWorker.addEventListener("message", (e) => {
      if (e.data?.type === "sw-updated") doReload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
